import { ISystemUserDetailDTO } from "api/swagger/ApiClient";
import { CountryWrapper, SystemUserWrapper } from "model/support-types";

export interface UserCountryRoleModel {
  user: ISystemUserDetailDTO;
  countriesApproveWrapper: CountryWrapper[];
  countriesContactWrapper: CountryWrapper[];
  approverDelegatesWrapper: SystemUserWrapper[];
  delegateApproversWrapper: SystemUserWrapper[];
  isVisible: boolean;
  isExpanded: boolean;
  isUserEditing: boolean;
  isCountryApproveEditing: boolean;
  isCountryContactEditing: boolean;
  isApproverDelegateEditing: boolean;
  isDelegateApproverEditing: boolean;
  saveUser(item: ISystemUserDetailDTO): Promise<ISystemUserDetailDTO>;
  addNewCountryApprove(country: CountryWrapper): Promise<void>;
  removeCountryApprove(country: CountryWrapper): Promise<void>;
  addNewCountryContact(country: CountryWrapper): Promise<void>;
  removeCountryContact(country: CountryWrapper): Promise<void>;
  addNewApproverDelegate(user: SystemUserWrapper): Promise<void>;
  removeApproverDelegate(user: SystemUserWrapper): Promise<void>;
  addNewDelegateApprover(user: SystemUserWrapper): Promise<void>;
  removeDelegateApprover(user: SystemUserWrapper): Promise<void>;
}
